<fui-filter-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                   [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-filter-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                              [title]="label" [valued]="valued"></fui-filter-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        <fui-fixture *ngIf="!disabled">
            <fui-icon [height]="12" [icon]="'calendar'" [width]="12"
                      [clickable]="true" (click)="toggle($event)"></fui-icon>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <kendo-dateinput #input [(ngModel)]="value" (focus)="onFocus($event)" (blur)="onBlur($event)"
                                 [format]="'dd/MM/yyyy'" [disabled]="disabled" [tabindex]="tabindex"></kendo-dateinput>
            </fui-input-dom>
        </fui-spanning-fixture>
    </fui-fixtures>
</fui-filter-fascia>
<fui-date-pop [popped]="popped" (popped$)="pop($event)" (click)="popClicked($event)">
    <kendo-calendar *ngIf="popped" #calendar [(ngModel)]="value" (valueChange)="calendarChanged($event)"></kendo-calendar>
</fui-date-pop>
